import {computed} from "vue";
import {cacheKey} from "@/lib/cache";
import useSwr from "@/core/composables/swr/useSwr";
import useOrganizationId from "@/core/composables/useOrganizationId";
import {frequentationApi} from "@/container";
import {FrequentationYear} from "@/core/interfaces/Frequentation";

/**
 * Composable to fetch the activity of the last 52 weeks of the user's
 * pharmacy, for the yearly view of the frequentation screen.
 *
 * @param enabled Whether the data is wanted at all: false while the yearly
 *                view is not displayed, so a screen opened on the week does
 *                not pay for a year it may never look at.
 */
const useFrequentationYear = (enabled: () => boolean = () => true) => {
    const organizationId = useOrganizationId();

    const key = computed(() => {
        if (!organizationId.value || !enabled()) {
            return null;
        }

        return cacheKey(`organizations/${organizationId.value}/frequentation/year`);
    });

    const {data, isLoading, error} = useSwr<FrequentationYear | null>(
        () => key.value,
        () => frequentationApi().year()
    );

    return {
        year: computed(() => data.value ?? null),
        isLoading,
        error
    };
};

export default useFrequentationYear;
